export default __webpack_public_path__ + "static/media/AdobeStock_479460855.ce2b4340.jpg";